<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-flex px-4 mt-4>
                    <v-layout row :wrap="$bp.smallScreen" align-baseline class="mt-3">
                    <!-- create a article -->
                        <v-flex px-0>
                            <v-form ref="create_article" @submit.prevent>
                                <v-flex>
                                    <bc-autocomplete
                                        v-model="mod"
                                        :label="$t('lang.select_a_module')"
                                        :items="modules"
                                        item-text="display_name"
                                        item-value="module_id"
                                        class="mt-0"
                                        :rules="ifValid('english_article.module_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <!-- ENGLISH ARTICLE -->
                                <v-flex v-if="english">
                                    <h3 class="headline mb-2 mt-2">{{english.language}}</h3>
                                        <v-text-field
											v-model="english_article.title"
											:label="`${$t('lang.article_title')} *`"
											:counter="showCounter(english_article.title, 'english_article.title')"
											:rules="ifValid('english_article.title')"
                                        ></v-text-field>
                                        <v-textarea
                                            v-model="english_article.article"
											:label="`${$t('lang.write_article')} *`"
											auto-grow
											rows="1"
											:rules="ifValid('english_article.article')"
                                        ></v-textarea>
                                </v-flex>
                            </v-form>
                            <!-- OTHER LANG ARTICLES -->
                            <v-flex v-for="(lang, index) in active_languages" :key="index">
                                <h3 class="headline mb-2 mt-2">{{lang.language}}</h3>
                                <v-form ref="create_article_other_lang">
                                    <v-text-field
                                        v-model="new_article[index].title"
                                        :label="`${$t('lang.article_title')} *`"
                                        :counter="showCounter(new_article[index].title, 'english_article.title')"
                                        :rules="ifValid('english_article.title')"
                                    ></v-text-field>
                                    <v-textarea
                                        v-model="new_article[index].article"
                                        :label="`${$t('lang.write_article')} *`"
                                        auto-grow
                                        rows="1"
                                        :rules="ifValid('english_article.article')"
                                    ></v-textarea>
                                </v-form>
                            </v-flex>
                            <v-btn class="mx-0 px-0 my-3 elevation-0" :style="$bp.lgAndUp ? 'width: 200px' : null" color="success" @mouseup.left="createArticle()">{{$t('lang.create_article')}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            new_title: "",
            active_languages: [],
            english: {},
            english_article: {
                status: 9,
                language: "en",
                module_id: null,
                title: "",
                article: "",
            },
            new_article: [],
            mod: null,
        };
    },
    watch: {
        mod() {
            this.english_article.module_id = this.mod;
            this.new_article.forEach((article) => {
                return (article.module_id = this.mod);
            });
        },
    },
    computed: {
        ...mapState({
            rules_english_article: (state) => state.validation.rules_english_article,
        }),
        ...mapGetters(["modules", "currentRoute"]),
    },
    beforeRouteEnter(to, from, next) {
        //get the modules
        const modules = new Promise((resolve, reject) => {
            if (store.getters.modules == null) {
                store
                    .dispatch("fetchModules", {
                        url: "modules",
                        method: "get",
                        stateProperty: "modules",
                        commit: true,
                        localStorage: true,
                    })
                    .then((data) => {
                        typeof data !== "undefined" ? resolve(data.modules) : reject(new Error("reject"));
                    });
            } else {
                resolve(store.getters.modules);
            }
        });

        //get the languages
        const languages = new Promise((resolve, reject) => {
            store
                .dispatch("fetchLanguages", {
                    url: "languages",
                    method: "get",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.languages) : reject(new Error("reject"));
                });
        });

        Promise.all([languages, modules])
            .then(([languages, modules]) => {
                next((vm) => {
                    if (store.getters.currentRoute != null) {
                        let checkRoute = store.getters.currentRoute;
                        vm.modules.forEach((mod) => {
                            if (mod.module == checkRoute || mod.display_name.toLowerCase() == checkRoute) {
                                vm.mod = mod.module_id;
                            }
                        });
                    }
                    vm.active_languages = languages.filter((language) => {
                        return language.status == 1 && language.iso != "en";
                    });

                    let english = languages.filter((language) => {
                        return language.iso == "en";
                    });

                    vm.english = english[0];

                    for (let i = 0; i < vm.active_languages.length; i++) {
                        vm.new_article.push({
                            module_id: vm.mod,
                            language: vm.active_languages[i].iso,
                            article: "",
                            title: "",
                            status: 9,
                        });
                    }

                    vm.finishLoader();
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        //get the modules
        const modules = new Promise((resolve, reject) => {
            if (store.getters.modules == null) {
                this.$store
                    .dispatch("fetchModules", {
                        url: "modules",
                        method: "get",
                        stateProperty: "modules",
                        commit: true,
                        localStorage: true,
                    })
                    .then((data) => {
                        typeof data !== "undefined" ? resolve(data.modules) : reject(new Error("reject"));
                    });
            } else {
                resolve(store.getters.modules);
            }
        });

        //get the languages
        const languages = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchLanguages", {
                    url: "languages",
                    method: "get",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.languages) : reject(new Error("reject"));
                });
        });

        Promise.all([languages, modules])
            .then(([languages, modules]) => {
                if (this.currentRoute != null) {
                    this.modules.forEach((mod) => {
                        if (mod.module == this.currentRoute || mod.display_name.toLowerCase() == this.currentRoute) {
                            this.mod = mod.module_id;
                        }
                    });
                }

                this.active_languages = languages.filter((language) => {
                    return language.status == 1 && language.iso != "en";
                });

                let english = languages.filter((language) => {
                    return language.iso == "en";
                });

                this.english = english[0];

                for (let i = 0; i < this.active_languages.length; i++) {
                    this.new_article.push({
                        module_id: this.mod,
                        language: this.active_languages[i].iso,
                        article: "",
                        title: "",
                        status: 9,
                    });
                }

                this.finishLoader();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    methods: {
        createArticle() {
            this.$store.commit("validationOn");
            //only grab the articles that have been filled out to send off to the api
            this.$nextTick(() => {
                if (this.validateForm("create_article")) {
                    let body = { help_articles: [] };

                    body.help_articles = this.new_article.filter((article) => {
                        return article.title.length && article.article.length > 0;
                    });

                    body.help_articles.push(this.english_article);

                    this.startLoader();
                    this.$store
                        .dispatch("fetchHelp", {
                            url: "help",
                            method: "post",
                            body,
                        })
                        .then(() => {
                            this.english_article.title = "";
                            this.english_article.article = "";
                            this.new_article.forEach((article) => {
                                article.title = "";
                                article.article = "";
                            });
                            this.$store.commit("validationOff");
                            this.finishLoader();
                        });
                }
            });
        },
        getLanguages() {
            this.startLoader();
            this.$store
                .dispatch("fetchLanguages", {
                    url: "languages",
                    method: "get",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    this.active_languages = data.languages.filter((language) => {
                        return language.status == 1 && language.iso != "en";
                    });

                    let english = data.languages.filter((language) => {
                        return language.iso == "en";
                    });

                    this.english = english[0];

                    for (let i = 0; i < this.active_languages.length; i++) {
                        this.new_article.push({
                            module_id: this.mod,
                            language: this.active_languages[i].iso,
                            article: "",
                            title: "",
                            status: 9,
                        });
                    }
                    this.finishLoader();
                });
        },
    },
};
</script>
